<template>
  <v-checkbox
    v-model="checkbox"
    :name="name"
    :id="id"
    :value="value"
    :label="label"
  ></v-checkbox>
</template>

<script>
export default {
  props: ['name', 'id', 'value', 'label', 'checked'],
  data() {
    return {
      checkbox: [this.checked],
    };
  },
  methods: {},
  computed: {},
};
</script>
